<mat-form-field appearance="outline">
  <mat-label>{{ label() }}</mat-label>
  <input matInput [matDatepicker]="picker" (keydown)="preventAutocomplete($event)" [formControl]="control()" />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
